var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 0C4.75622 0 2.66667 2.08757 2.66667 4.66406C2.66667 7.24055 4.75622 9.32812 7.33333 9.32812C9.91045 9.32812 12 7.24055 12 4.66406C12 2.08757 9.91045 0 7.33333 0Z",
    fill: "#F85489"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.66667V9.33333H13.3333V10.6667H16V13.3333H17.3333V10.6667H20V9.33333H17.3333V6.66667H16Z",
    fill: "#F85489"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.9922L4.66666 11.9922C2.08948 11.9922 0 14.0807 0 16.6582V19.9878L14.6667 19.9878V16.6582C14.6667 14.0807 12.5772 11.9922 10 11.9922Z",
    fill: "#F85489"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAdmin);
export default __webpack_public_path__ + "static/media/addAdmin.f159fcc08e8b140f1c14e8d7717e9a4f.svg";
export { ForwardRef as ReactComponent };